import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { BadgeModel } from '@flocasts/experience-service-types'
import { trackById } from '../../shared/utility-functions/track-by-id.utility'

@Component({
  selector: 'flo-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BadgeComponent {
  @Input()
  badge: BadgeModel
  protected readonly trackById = trackById
}
